import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { clinicInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border-light)',
      padding: '80px 0 40px'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '60px'
        }}>
          {/* About Section */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>OdontoDentine</h3>
            <p className="body-regular" style={{ marginBottom: '24px' }}>
              Cuidar do seu sorriso é transformar o seu bem-estar.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a 
                href={clinicInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '40px',
                  height: '40px',
                  border: '1px solid var(--border-medium)',
                  borderRadius: '0px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  color: 'var(--text-primary)'
                }}
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>Links Rápidos</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  Início
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/sobre" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  Sobre Nós
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/tratamentos" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  Tratamentos
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/contato" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>Contato</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '16px', display: 'flex', gap: '12px' }}>
                <Phone size={18} style={{ color: 'var(--text-secondary)', marginTop: '2px', flexShrink: 0 }} />
                <a href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`} className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  {clinicInfo.phoneDisplay}
                </a>
              </li>
              <li style={{ marginBottom: '16px', display: 'flex', gap: '12px' }}>
                <Mail size={18} style={{ color: 'var(--text-secondary)', marginTop: '2px', flexShrink: 0 }} />
                <a href={`mailto:${clinicInfo.email}`} className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                  {clinicInfo.email}
                </a>
              </li>
              <li style={{ display: 'flex', gap: '12px' }}>
                <MapPin size={18} style={{ color: 'var(--text-secondary)', marginTop: '2px', flexShrink: 0 }} />
                <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                  {clinicInfo.address.building}<br />
                  {clinicInfo.address.street}<br />
                  {clinicInfo.address.neighborhood}, {clinicInfo.address.city} - {clinicInfo.address.state}
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>Horário de Atendimento</h3>
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              {clinicInfo.hours}
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '24px',
          textAlign: 'center'
        }}>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>
            © {new Date().getFullYear()} OdontoDentine. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;